import { call, put, select } from 'redux-saga/effects';
import { ContentLibraryOpenedWhiteboard } from 'features/content-library/types';
import { isPrivateWhiteboard } from 'features/content-library/utils/isPrivateWhiteboard';
import { openLastActiveWhiteboardSaga } from 'features/content-library/sagas/openLastActiveWhiteboardSaga';
import { GridPanelName } from 'features/layout/features/content/types';
import { selectGridPanel } from 'features/layout/features/content/contentSlice';
import { managePrivateWhiteboardPermissionRevoked } from 'features/permissions/actions';
import { UserId } from 'features/users/types';
import { selectLocalUserId } from 'features/users/usersSlice';
import {
  activeWhiteboardsCollectionReplaced,
  selectContentLibraryActiveWhiteboards,
} from 'features/content-library/contentLibrarySlice';

export function* onManagePrivateWhiteboardPermissionRevokedSaga(
  action: ReturnType<typeof managePrivateWhiteboardPermissionRevoked>
) {
  const { id } = action.payload;
  const localUserId: UserId = yield select(selectLocalUserId);

  if (id !== localUserId) {
    return;
  }

  const whiteboards: ContentLibraryOpenedWhiteboard[] = yield select(
    selectContentLibraryActiveWhiteboards
  );

  const filteredWhiteboards = whiteboards.filter((item) => !isPrivateWhiteboard(item));

  const whiteboardsRecord = filteredWhiteboards.reduce(
    (result, whiteboard) => {
      result[whiteboard.id] = whiteboard;

      return result;
    },
    {} as Record<string, ContentLibraryOpenedWhiteboard>
  );

  yield put(activeWhiteboardsCollectionReplaced(whiteboardsRecord));

  const currentGridPanel: GridPanelName = yield select(selectGridPanel);

  if (currentGridPanel === 'whiteboard') {
    yield call(openLastActiveWhiteboardSaga);
  }
}
